/**
 * Normaliza a base da API: remove barras finais e sufixos `/api` repetidos.
 * Evita URLs como `https://host/api/api/admin/...` ou `.../api/api/media?key=` (404).
 */
export function normalizeApiOrigin(raw: string): string {
  let s = raw.trim().replace(/\/+$/, '');
  while (s.toLowerCase().endsWith('/api')) {
    s = s.slice(0, -4).replace(/\/+$/, '');
  }
  return s;
}
